module.exports = __webpack_public_path__ + "static/media/grey-wave.e608e413.svg";